import { Flex } from "antd";
import { AiFitAnalysis } from "../lib/aiFitCheckUtils";
import { BulletList, ScoreRow } from "./parts";
import styles from "./styles.module.scss";

const SCORE_LABELS: Record<keyof AiFitAnalysis["score_breakdown"], string> = {
  creator_profile_fit: "Creator profile",
  audience_fit: "Audience",
  content_fit: "Content",
  brand_integration_fit: "Brand integration",
  performance_signal: "Performance",
  safety_fit: "Safety",
  confidence_quality: "Confidence",
};

export function ScoresTab({ data }: { data: AiFitAnalysis }) {
  const breakdown = data.score_breakdown;
  const reasons = data.fit_reasons;
  const keys = Object.keys(SCORE_LABELS) as Array<keyof typeof SCORE_LABELS>;

  return (
    <Flex vertical gap={20}>
      <Flex vertical gap={12}>
        {keys.map((key) => (
          <ScoreRow
            key={key}
            label={SCORE_LABELS[key]}
            score={breakdown?.[key]?.score}
            reason={breakdown?.[key]?.reason}
          />
        ))}
      </Flex>

      {reasons?.strongest_evidence?.length ||
      reasons?.weakest_evidence?.length ? (
        <div className={styles.twoCol}>
          {reasons?.strongest_evidence?.length ? (
            <div className={`${styles.panel} ${styles.panelSuccess}`}>
              <p className={`${styles.miniLabel} ${styles.miniLabelMatch}`}>
                Strongest evidence
              </p>
              <BulletList items={reasons.strongest_evidence} />
            </div>
          ) : null}
          {reasons?.weakest_evidence?.length ? (
            <div className={`${styles.panel} ${styles.panelWarning}`}>
              <p className={`${styles.miniLabel} ${styles.miniLabelMismatch}`}>
                Weakest evidence
              </p>
              <BulletList items={reasons.weakest_evidence} />
            </div>
          ) : null}
        </div>
      ) : null}
    </Flex>
  );
}
